import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import ClickOutside from 'react-click-outside';
import moment from 'moment-timezone';
import { Map } from 'immutable';

import Quote from 'models/quote';
import { Location } from 'models/locations';


import StarCar from 'components/svgs/StarCar';
import ToggleButton from 'components/checkout/parking-details/time-picker/auto-extend-tooltip/toggle-button';

const propTypes = {
  directAffiliateTraffic: PropTypes.bool,
  bookExtendedTimes: PropTypes.bool.isRequired,
  timezone: PropTypes.string.isRequired,
  showAutoExtendTooltip: PropTypes.bool,
  selectedQuote: PropTypes.instanceOf(Quote),
  selectedLocation: PropTypes.instanceOf(Location),
  sellers: PropTypes.instanceOf(Map),
  toggleBookExtendedTimes: PropTypes.func.isRequired,
  hideAutoExtendTooltip: PropTypes.func.isRequired,
};

const defaultProps = {
  selectedQuote: new Quote(),
  selectedLocation: new Location(),
  sellers: Map(),
  directAffiliateTraffic: false,
  showAutoExtendTooltip: false,
};

export class AutoExtendTooltip extends Component {
  constructor(props) {
    super(props);

    this.handleToggleBookExtendedTimes = this.handleToggleBookExtendedTimes.bind(this);
  }

  handleToggleBookExtendedTimes() {
    this.props.toggleBookExtendedTimes();
  }

  render() {
    if (!this.props.showAutoExtendTooltip) { return null; }

    const {
      bookExtendedTimes,
      sellers,
      timezone,
      selectedQuote,
      selectedLocation,
      directAffiliateTraffic,
    } = this.props;

    if (directAffiliateTraffic) { return null; }

    const { minStartTime, maxEndTime } = selectedQuote;
    const parkingMinStart = moment(minStartTime).tz(timezone);
    const parkingMaxEnd = moment(maxEndTime).tz(timezone);
    const formattedMinStart = moment().isSame(parkingMinStart, 'day') ? parkingMinStart.format('h:mm A') : parkingMinStart.format('MMMM Do, h:mm A');
    const formattedMaxEnd = moment().isSame(parkingMaxEnd, 'day') ? parkingMaxEnd.format('h:mm A') : parkingMaxEnd.format('MMMM Do, h:mm A');

    const seller = sellers.get(selectedLocation.sellerId.toString());

    return (
      <ClickOutside onClickOutside={this.props.hideAutoExtendTooltip} >
        <div
          className="auto-extend-details display-toggle"
          onClick={this.handleToggleBookExtendedTimes}
        >
          <span className="margin-top-10 display-inline-block">
            <StarCar />
          </span>
          <div className="auto-extend-message">
            <FormattedMessage
              id="checkout.extend-message"
              defaultMessage="At this {sellerName} facility, {extendedStartTime} to {extendedEndTime} costs the same as the time you selected. The extra time has been added to your booking&mdash;stay until {extendedEndTime} if you like!"
              values={{
                sellerName: seller.name,
                extendedStartTime: formattedMinStart,
                extendedEndTime: formattedMaxEnd,
              }}
            />
          </div>
          <ToggleButton
            display
            bookExtendedTimes={bookExtendedTimes}
          />
        </div>
      </ClickOutside>
    );
  }
}

AutoExtendTooltip.propTypes = propTypes;
AutoExtendTooltip.defaultProps = defaultProps;

export default AutoExtendTooltip;
